// react
import moment from "moment";
import { Map, fromJS } from "immutable";

// dependencies
import Cookies from "js-cookie";

// config
import Config from "Config";

export const initialState = fromJS({
	requestTracker: {},
	user: {
		roles: ["logan-default-user"],
		environments: Config.environments.map((environment) => environment.name),
	},
	token: null,
	environment: Cookies.get("environment") || "production",
});

export default function appState(state = initialState, action) {
	switch (action.type) {
		case "APP:AUTHTOKEN.SAVE": {
			return state.set("token", action.token);
		}

		case "APP:USER.ROLES": {
			return state.setIn(["user", "roles"], action.roles);
		}

		case "APP:USER.ALLOWEDENVIRONMENTS": {
			return state.setIn(["user", "environments"], fromJS(action.environments));
		}

		case "APP:ENVIRONMENTCHANGE": {
			Cookies.set("environment", action.environment);
			return state.set("environment", action.environment);
		}

		case "REQUEST:TRACKER": {
			if (action.direction === "outgoing") {
				return state.setIn(["requestTracker", action.name], Map({ sent: moment(), received: null }));
			}

			return state.setIn(["requestTracker", action.name, "received"], moment());
		}

		default:
			return state;
	}
}
